<div class="switch-button-container">
    <label *ngIf="label" class="button-container__label">{{ label | translate }}</label>
    <label class="button-container__toggle" [for]="inputId + '-switch'">
        <input class="toggle__toggle-input" name="" [checked]="checked" type="checkbox" [id]="inputId + '-switch'" (change)="checkboxChanged($event)">
        <div class="toggle__toggle_fill"></div>
    </label>
</div>
